export interface ListReturnState<T> {
  account: string;
  path: string;
  page: number;
  filters: T;
  scrollY: number;
}

export function readListReturnState<T>(
  account: string | null,
  path: string
): ListReturnState<T> | null {
  if (!account || typeof window === "undefined") return null;
  const saved = window.history.state?.listReturn;
  return saved?.account === account &&
    saved.path === path &&
    Number.isSafeInteger(saved.page) &&
    saved.page > 0 &&
    saved.filters &&
    Number.isFinite(saved.scrollY) &&
    saved.scrollY >= 0
    ? saved
    : null;
}

export function saveListReturnState<T>(
  account: string | null,
  path: string,
  page: number,
  filters: T,
  scrollY?: number
): void {
  if (
    !account ||
    typeof window === "undefined" ||
    window.history.state?.current !== path
  )
    return;
  window.history.replaceState(
    {
      ...window.history.state,
      listReturn: {
        account,
        path,
        page,
        filters: JSON.parse(JSON.stringify(filters)),
        scrollY: scrollY ?? window.scrollY,
      },
    },
    ""
  );
}

export function captureListScroll(account: string | null, path: string): void {
  const saved = readListReturnState<unknown>(account, path);
  if (saved) saveListReturnState(account, path, saved.page, saved.filters);
}
